import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { Typography } from '@mui/material'
import { CompatibilityWarningLayout } from '$common/compatibility-warning-layout'
import { t } from '$i18n'
import { MADRESE_TAALI_MOGHAVEMAT_ROOMID } from '$logic/profile'
import { HallAvatar } from '$common/avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { ArrowIOSIcon } from '$common/icons'
import { isInTwa } from '$func/environmentInfo'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'
import { registerNotification } from '$setup/notification'

// #moghavemat
export function NotifActivation({ isOpen }: { isOpen: boolean }) {
  return (
    <CompatibilityWarningLayout
      isOpen={isOpen}
      icon={
        <HallAvatar
          roomId={MADRESE_TAALI_MOGHAVEMAT_ROOMID}
          size={AvatarSize._3XL}
        />
      }
      title={t('armanema.notifActivation.title')}
      description={
        <Typography variant="paragraph1" textAlign="center">
          {t('armanema.notifActivation.description')}
        </Typography>
      }
      onClose={closeCurrentModal}
      hideIconContainer
      onClick={() => {
        if (isInTwa) sendEventToTwa(TWA_EVENTS.CHECK_NOTIF_PERMISSION)
        else registerNotification()
        closeCurrentModal()
      }}
      actionText={t('common.resume')}
      endIcon={<ArrowIOSIcon sx={{ color: 'neutral900' }} />}
    />
  )
}
